import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import "./index.css";
import App from "./app";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import store from "./redux/store";

const container = document.getElementById("root") as HTMLElement;

const rootContainer = ReactDOM.createRoot(container);

rootContainer.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <ToastContainer hideProgressBar />
        <App />
      </Provider>
    </React.StrictMode>
  </BrowserRouter>
);
